import { useQuery } from "@tanstack/react-query";

import { getAlertData, getCTAData } from "./fetch";
import { mmgKeys } from "./keys";

export const useGetAlertData = () => {
  return useQuery({
    queryKey: mmgKeys.alerts(),
    queryFn: getAlertData,
  });
};

export const useGetCTAData = () => {
  return useQuery({
    queryKey: mmgKeys.cta(),
    queryFn: getCTAData,
  });
};
